module.exports = __webpack_public_path__ + "static/media/pytorch.abd5f21f.png";